
<div class="modal-dialog" style="min-width:780px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Import Accounts</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
      <div class="col" *ngIf="processing">
        <md-spinner-block></md-spinner-block>
      </div>
      <table class="table table-striped" *ngIf="!processing">
        <thead>
          <tr class="table-header-with-controls">
            <th class="w1pct"></th>
            <th>Regional Name</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let account of listAccounts; let idx = index;">
            <td><span class="text-green oi-check" *ngIf="account.selected"></span></td>
            <td>{{ account.regionalName }}</td>
            <td>
              <button class="btn btn-primary btn-sm" *ngIf="!account.selected" type="button" (click)="selectAccount(account.id)">Select</button>
            </td>
          </tr>
          <tr *ngIf="listAccounts.length === 0">
            <td [attr.colspan]="4">
              <p class="text-center empty-table-message">There are no accounts to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>